module.exports = __webpack_public_path__ + "img/public/AdminIcons/reservationIcon.svg?2d10720f";